export enum DurationUnit {
  minute = 0,
  hour = 1,
  day = 2,
  week = 3,
  month = 4,
  year = 5
}